import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface ModerationPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isNextDisabled: boolean;
  isPrevDisabled: boolean;
}

/**
 * ページネーションコンポーネント
 * - 前のページ/次のページボタン
 * - 現在ページ/総ページ数表示
 * - ボタンの有効/無効制御
 */
const ModerationPagination: React.FC<ModerationPaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  isNextDisabled,
  isPrevDisabled
}) => {
  const handlePrevPage = () => {
    if (!isPrevDisabled) {
      onPageChange(Math.max(currentPage - 1, 1));
    }
  };

  const handleNextPage = () => {
    if (!isNextDisabled) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="compact-pagination">
      <button
        className="pagination-button-compact prev"
        onClick={handlePrevPage}
        disabled={isPrevDisabled}
        title="前のページ"
      >
        <ChevronLeft size={16} />
      </button>

      <div className="pagination-info-compact">
        <span className="page-current">{currentPage}</span>
        <span className="page-separator">/</span>
        <span className="page-total">{totalPages}</span>
      </div>

      <button
        className="pagination-button-compact next"
        onClick={handleNextPage}
        disabled={isNextDisabled}
        title="次のページ"
      >
        <ChevronRight size={16} />
      </button>
    </div>
  );
};

export default ModerationPagination;
